import * as React from 'react';
import ReactDOM from 'react-dom';

import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';

// import AppStep1Level1 from './AppStep1Level1';
// import AppStep1Level2 from './AppStep1Level2';
import AppStep3 from './AppStep3';

import './index.css';

ReactDOM.render(
	<React.StrictMode>
		<ChakraProvider resetCSS>
			<ColorModeScript />
			{/* <AppStep1Level1 /> */}
			{/* <AppStep1Level2 /> */}
			<AppStep3 />
		</ChakraProvider>
	</React.StrictMode>,
	document.getElementById('root'),
);
